import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A wooden utility pole: a tall creosoted timber with a crossarm near the top,
// ceramic pin insulators along the arm, and a small grey transformer can on the
// side. The everyday roadside distribution pole.
const WOOD = "#6e4f2e";
const ARM = "#5a4128";
const INSUL = "#9aa6ad";
const CAN = "#8f969c";
const CABLE = "#2a2a2e";

export const utilityPole = defineModel({
  id: "utility-pole",
  batchId: "electric",
  name: "Utility pole",
  tags: ["prop", "electric", "power", "grid", "distribution", "pole", "wood"],
  summary: "A wooden distribution pole with a crossarm, insulators and a transformer.",
  footprint: 0.4,
  parts(): Part[] {
    return [
      // The pole.
      { geometry: new THREE.CylinderGeometry(0.05, 0.065, 1.9, 10), color: WOOD, position: [0, 0.95, 0] },
      // Crossarm near the top.
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.07), color: ARM, position: [0, 1.72, 0] },
      // A second, shorter arm below.
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.06), color: ARM, position: [0, 1.5, 0] },
      // Pin insulators on the top arm.
      { geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.08, 8), color: INSUL, position: [-0.3, 1.79, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.08, 8), color: INSUL, position: [0, 1.79, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.08, 8), color: INSUL, position: [0.3, 1.79, 0] },
      // Insulators on the lower arm.
      { geometry: new THREE.CylinderGeometry(0.025, 0.03, 0.07, 8), color: INSUL, position: [-0.2, 1.56, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.03, 0.07, 8), color: INSUL, position: [0.2, 1.56, 0] },
      // Pole-mounted transformer can.
      { geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.26, 12), color: CAN, position: [0.13, 1.2, 0.02] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.03, 12), color: "#7a8086", position: [0.13, 1.34, 0.02] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.022, 0.06, 6), color: INSUL, position: [0.07, 1.37, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.022, 0.06, 6), color: INSUL, position: [0.19, 1.37, 0.06] },
      // A service drop wire running down the side of the pole.
      { geometry: new THREE.CylinderGeometry(0.007, 0.007, 1.1, 6), color: CABLE, position: [0.07, 0.65, 0.05] },
    ];
  },
  animations: [],
});
